export default {
  en: {
    panelTitle: 'Your uploads',
    panelSubtitle: 'All your private documents and files that you upload for this supplier',
    upload: 'Upload documents',
    uploadError: 'Failed to save the document. Try again.',
    uploadsLabel: 'Upload status',
    uploadsInProgress: 'Uploading {n} document | Uploading {n} documents',
    uploadsComplete: '{n} upload complete | {n} uploads complete',
    uploadsFailed: '({n} failed)',
    searchPlaceholder: 'Search documents',
    entityName: 'documents',
    filterAttributes: {
      expiryStatus: 'Expiry status',
      expired: 'Expired',
      expiringSoon: 'Expiring soon',
      valid: 'Valid',
      noExpiry: 'No expiry',
      dateAdded: 'Date added',
    },
    columnName: 'Name',
    columnType: 'Type',
    columnDateAdded: 'Date added',
    columnExpiry: 'Expiry',
    noExpiry: 'No expiry',
    attachedToNotes: 'Attached to {n} private note | Attached to {n} private notes',
    actions: 'Actions for {title}',
    download: 'Download',
    downloadError: 'Failed to download the document. Try again.',
    rename: 'Rename',
    renameTitle: 'Rename document',
    renameError: 'Failed to rename the document. Try again.',
    replace: 'Replace',
    replaceError: 'Failed to replace the file. Try again.',
    replaceRejected: 'That file failed processing, so the document is unchanged.',
    previewFile: 'Preview file',
    thumbnailUnavailableTitle: 'Thumbnail unavailable',
    thumbnailUnavailableSubtitle: 'You can still preview this file',
    editExpiry: 'Edit expiry',
    removeExpiry: 'Remove expiry',
    expiryError: 'Failed to save the expiry. Try again.',
    detailsTab: 'Details',
    activityTab: 'Activity',
    uploadedBy: 'Uploaded by',
    lastModified: 'Last modified',
    versionLabel: 'Version {number} of {total}',
    currentVersion: 'Current',
    privateNotesTab: 'Private notes',
    noPrivateNotesTitle: 'Not attached to a note',
    noPrivateNotesSubtitle: 'Attach this document to a private note to give it context',
    bulkActions: 'Actions',
    deleteSelected: 'Delete selected',
    deleteTitle: 'Delete this document?',
    deleteDescription:
      'This removes "{title}" from Documents. Its linked notes stay in Private notes, and any renewal reminder is removed. This can\'t be undone.',
    deleteAction: 'Delete document',
    deleteAttachedWarning:
      'This document is attached to a private note. | This document is attached to {n} private notes.',
    bulkDeleteTitle: 'Delete {n} document? | Delete {n} documents?',
    bulkDeleteDescription:
      "This removes {n} document from Documents. Its linked notes stay in Private notes. This can't be undone. | This removes {n} documents from Documents. Their linked notes stay in Private notes. This can't be undone.",
    bulkDeleteAction: 'Delete document | Delete documents',
    bulkDeleteAttachedWarning:
      'One of these is attached to a private note. | {n} of these are attached to private notes.',
    deleteError: 'Failed to delete the document. Try again.',
    bulkDeleteError: 'Failed to delete the documents. Try again.',
    bulkDownload: 'Download selected',
    bulkDownloadError: 'Failed to download the documents. Try again.',
    bulkDownloadTooLarge: 'You can download up to {limit} at once. Select fewer documents.',
    bulkDownloadOmitted:
      "1 document isn't in the zip: {details} | {n} documents aren't in the zip: {details}",
    bulkDownloadOmittedScanning: '{title} is still being checked',
    bulkDownloadOmittedScanRejected: '{title} failed its security check',
    bulkDownloadOmittedFileMissing: "{title}'s file is unavailable",
    bulkDownloadOmittedFetchFailed: '{title} could not be downloaded',
    emptyTitle: 'No documents added',
    emptySubtitle: 'Add a document and it will be visible here',
    noResultsTitle: 'No matching documents',
    noResultsSearchSubtitle: 'Try a different search',
    noResultsFilterSubtitle: 'Try a different filter',
    noResultsSearchFilterSubtitle: 'Try a different search or filter',
    errorTitle: "We couldn't load your documents",
    errorSubtitle: 'Retry, or reload the page if this continues',
    errorRetry: 'Retry',
    attachTitle: 'Attach a document',
    attachDescription: 'Choose a file already in Documents, or upload a new one.',
    attachAction: 'Attach {n} document | Attach {n} documents',
    attachUploadNew: 'Upload new',
    attachSelectExisting: 'Select existing',
    attachmentPreview: 'Preview',
    attachmentRemove: 'Remove {0}',
    attachmentProcessing: "Checking this file. We'll attach it once the scan finishes.",
    attachmentFailed: "We can't attach this file. Remove it and try again.",
    attachUploadNewDocument: 'Upload new document',
    attachAlreadyAttached: 'Attached',
    attachNoneSelected: 'Select at least one document',
    attachEmptySubtitle: 'Upload one to attach it',
    attachNoResultsTitle: 'No documents match "{0}"',
    attachNoResultsSubtitle: 'Upload it to attach it',
    attachFetchError: "We couldn't load your documents. Try again.",
    uploadNewTitle: 'Upload documents',
    uploadNewDescription: "We'll add them to Documents and attach them.",
    uploadNewEmptyTitle: 'No documents selected',
    uploadNewEmptySubtitle: 'Select one or more documents to upload.',
    uploadNewSelect: 'Select documents',
    uploadNewAddMore: 'Add more',
    uploadNewRemove: 'Remove {0}',
    uploadNewAction: 'Attach documents | Attach {n} document | Attach {n} documents',
  },
};
